import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
	providedIn: 'root',
})
export class PushNotificationService {
	public permission: Permission;

	constructor(private router: Router) {
		this.permission = this.isSupported() ? 'default' : 'denied';
	}

	public isSupported(): boolean {
		return 'Notification' in window;
	}

	requestPermission(): void {
		let self = this;
		if ('Notification' in window) {
			Notification.requestPermission(function (status) {
				return (self.permission = status);
			});
		}
	}

	create(title: string, options?: PushNotification): any {
		let self = this;
		const vm = this;
		return new Observable(function (obs) {
			let _notify = new Notification(title, options);
			_notify.onshow = function (e) {
				return obs.next({
					notification: _notify,
					event: e,
				});
			};
			_notify.onclick = function (e) {
				if (options?.url) {
					vm.router.navigate([`${options.url}`]);
				}
				return obs.next({
					notification: _notify,
					event: e,
				});
			};
			_notify.onerror = function (e) {
				return obs.error({
					notification: _notify,
					event: e,
				});
			};
			_notify.onclose = function () {
				return obs.complete();
			};
		});
	}

	generateNotification(source: Array<any>): void {
		let self = this;
		source.forEach((item) => {
			let options = {
				body: item.alertContent,
				icon: 'assets/images/icon.png',
			};
			if (item?.url) {
				options['url'] = item.url;
			}
			let notify = self.create(item.title, options).subscribe();
		});
	}
}

export declare type Permission = 'denied' | 'granted' | 'default';

export interface PushNotification {
	body?: string;
	icon?: string;
	tag?: string;
	data?: any;
	renotify?: boolean;
	silent?: boolean;
	sound?: string;
	noscreen?: boolean;
	sticky?: boolean;
	dir?: 'auto' | 'ltr' | 'rtl';
	lang?: string;
	vibrate?: number[];
	url?: string;
}
